import * as API from "middleware/api";

export const internalTransfer = (params) => API.executeWithAccessToken("/generate.transfer", { ...params });
export const otherTransfer = (params) => API.executeWithAccessToken("/generate.transfer.third.party", { ...params });
export const accountInfoByCbu = (params) => API.executeWithAccessToken("/read.third.party.account", { ...params });
export const transferClosingHourValidation = () => API.executeWithAccessToken("/generate.transfer.pre");

export const mepTransferValidation = () => API.executeWithAccessToken("/generate.mep.pre");
export const mepTransfer = (params) => API.executeWithAccessToken("/generate.mep.transfer", { ...params });
